<template>
  <div class="filters__locations">
    <div class="filters__locations-wrapper">
      <div class="filters__dropdown-wrapper">
        <label class="utility-flex" for="filters__location-dropdown">Region:</label>
        <select
          class="filters__location-dropdown filters__dropdown"
          @change="updateSelected"
          name="Regions"
          id="Regions"
          :selectedRegionID="selectedRegionID"
        >
          <option value="0">All regions</option>
          <option
            v-for="location in locations"
            :value="location.ID"
            :key="location.ID"
            >{{ location.Name }}</option
          >
        </select>
      </div>
      <FiltersSubregion
        :deleteSubRegions="deleteSubRegions"
        :disableSubRegionDropdown="disableSubRegionDropdown"
        :isTab2="isTab2"
        :selectedSubregions="selectedSubregions"
        :subRegionsForRegion="subRegionsForRegion"
        :updateSubRegions="updateSubRegions"
      ></FiltersSubregion>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FiltersSubregion from "./FiltersSubregion.vue";

export default Vue.component("FiltersLocations", {
  props: {
    deleteSubRegions: Function,
    disableSubRegionDropdown: Boolean,
    locations: Array,
    isTab2: Boolean,
    name: String,
    selectedRegionID: Array,
    selectedSubRegions: Array,
    subRegionsForRegion: Array,
    updateRegion: Function,
    updateSubRegions: Function,
  },
  components: {
    FiltersSubregion,
  },
  data() {
    return {
      selectedSubregions: [],
    };
  },
  methods: {
    updateSelected: function(event) {
      let selectedValue = event.target.value;
      this.updateRegion({ [this.name]: parseInt(selectedValue, 10) });
    },
  },
});
</script>
